import { render, staticRenderFns } from "./DialogAsignarCategoria.vue?vue&type=template&id=30acb540&scoped=true"
import script from "./DialogAsignarCategoria.vue?vue&type=script&lang=js"
export * from "./DialogAsignarCategoria.vue?vue&type=script&lang=js"
import style0 from "./DialogAsignarCategoria.vue?vue&type=style&index=0&id=30acb540&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30acb540",
  null
  
)

export default component.exports